import {
  Box,
  Button,
  Flex,
  GreyGrey80,
  IconFilter,
  MultiSelectControl,
  Primary13SemiBold,
  SettingsGroupSearch,
  Tooltip
} from '@sequencehq/core-components'
import { ReactNode } from 'react'

export type CountryFilterControl = {
  options: { label: string; value: string }[]
  values: string[]
  onChange: (countries: string[]) => void
}

export const IntegrationCustomerFilterBar = (props: {
  heading?: string
  subHeaderInfo?: ReactNode
  search: string
  onSearchChange: (value: string) => void
  countryFilter?: CountryFilterControl
  'data-testid': string
}) => {
  const dataTestId = props['data-testid']
  const countryFilter = props.countryFilter

  return (
    <Box>
      {props.heading && (
        <Flex gap="6px" alignItems="center" marginBottom="12px">
          <Box
            {...Primary13SemiBold}
            color={GreyGrey80}
            data-testid={`${dataTestId}.subHeader`}
          >
            {props.heading}
          </Box>
          {props.subHeaderInfo}
        </Flex>
      )}
      <Flex gap="8px" alignItems="center" marginBottom="16px">
        {countryFilter && countryFilter.options.length > 0 && (
          <MultiSelectControl
            data-testid={`${dataTestId}.countryFilter`}
            options={countryFilter.options}
            values={countryFilter.values}
            onChange={countryFilter.onChange}
            placeholder="Search countries"
            trigger={
              <Tooltip label="Filter by country">
                <Button
                  data-testid={`${dataTestId}.countryFilter.trigger`}
                  variant="secondary"
                  icon={<IconFilter />}
                  aria-label="Filter by country"
                />
              </Tooltip>
            }
          />
        )}
        <Box flex="1">
          <SettingsGroupSearch
            data-testid={`${dataTestId}.nameSearch`}
            placeholder="Search by name"
            value={props.search}
            onChange={e => props.onSearchChange(e.target.value)}
            width="100%"
            styles={{ wrapper: { marginBottom: '0' } }}
          />
        </Box>
      </Flex>
    </Box>
  )
}
